import { render, staticRenderFns } from "./DualAcceptances.vue?vue&type=template&id=729fd392"
import script from "./DualAcceptances.vue?vue&type=script&lang=js"
export * from "./DualAcceptances.vue?vue&type=script&lang=js"
import style0 from "./DualAcceptances.vue?vue&type=style&index=0&id=729fd392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports